import { ColumnDetails } from '../../../../grid/types/common';
import { TemplateResult } from 'lit';
import { convertNumberToHtmlSpanWithSecondaryFont } from '../../utils';
import { Column, ColumnKeys } from '../types';

export function modifyFontForNumbers(
  rowData: any,
  columnDetails: ColumnDetails<Column, ColumnKeys>
) {
  return convertNumberToHtmlSpanWithSecondaryFont(rowData.item[columnDetails.key]);
}
